import { type ComputedRef, computed } from 'vue';

import { TEMP_NEW_ONBOARDING_SMART } from '@/constants/feature_flags';
import { useFeatureFlagStore } from '@/stores/FeatureFlagStore';

export default function useHasSmartOnboardingAccess(): ComputedRef<boolean> {
  const { hasFeatureFlag } = useFeatureFlagStore();

  return computed(() => hasFeatureFlag(TEMP_NEW_ONBOARDING_SMART));
}
